import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBriefcase = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.5 1.75C7.5 0.784 8.284 0 9.25 0H14.75C15.716 0 16.5 0.784 16.5 1.75V4H21.25C22.216 4 23 4.784 23 5.75V20.25C23 20.7141 22.8156 21.1592 22.4874 21.4874C22.1592 21.8156 21.7141 22 21.25 22H2.75C2.28587 22 1.84075 21.8156 1.51256 21.4874C1.18437 21.1592 1 20.7141 1 20.25V5.75C1 4.784 1.784 4 2.75 4H7.5V1.75ZM2.5 11.99V20.25C2.5 20.388 2.612 20.5 2.75 20.5H21.25C21.3163 20.5 21.3799 20.4737 21.4268 20.4268C21.4737 20.3799 21.5 20.3163 21.5 20.25V11.99C20.7328 12.6433 19.7577 13.0014 18.75 13H5.25C4.24234 13.0014 3.26723 12.6433 2.5 11.99V11.99ZM21.5 8.75C21.5 9.47935 21.2103 10.1788 20.6945 10.6945C20.1788 11.2103 19.4793 11.5 18.75 11.5H5.25C4.52065 11.5 3.82118 11.2103 3.30546 10.6945C2.78973 10.1788 2.5 9.47935 2.5 8.75V5.75C2.5 5.6837 2.52634 5.62011 2.57322 5.57322C2.62011 5.52634 2.6837 5.5 2.75 5.5H21.25C21.3163 5.5 21.3799 5.52634 21.4268 5.57322C21.4737 5.62011 21.5 5.6837 21.5 5.75V8.75ZM15 1.75V4H9V1.75C9 1.6837 9.02634 1.62011 9.07322 1.57322C9.12011 1.52634 9.1837 1.5 9.25 1.5H14.75C14.8163 1.5 14.8799 1.52634 14.9268 1.57322C14.9737 1.62011 15 1.6837 15 1.75Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgBriefcase;
